import { environment } from '@orderna/admin-panel/src/environments/environment';

export const SALES_ANALYTICS_API_URL = `${environment.api}/analytics/sales`;
